// Pricing helpers — small read-side helpers over the tier registry.
// Engine modules use these instead of indexing inputs.tiers[k] directly so
// adding a 4th tier is a one-key change.

export function tierKeys(inputs) {
  return Object.keys(inputs.tiers);
}

export function getTier(inputs, key) {
  const t = inputs.tiers[key];
  if (!t) throw new Error(`Unknown tier "${key}"`);
  return t;
}

/**
 * Subscription revenue per active user in this tier (EUR / month). Free = 0.
 */
export function subscriptionRev(tier) {
  return tier.price;
}
